import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { MarketingPermissionsRoute } from 'sections/client-management/ui/pages/client-settings/marketing-permissions/routes';
import { AuthorisedSubNavLink } from '../../Auth/AuthorisedSubNavLink';
import { SubNavProps } from '../SubNavLinks';
import { generatePath } from 'react-router';

const SettingsSubNav: React.FC<SubNavProps> = props => {
  const { t } = useTranslation(['common', 'marketingPermissions']);
  useEffect(() => {
    props.setHeading(t('settings.label'));
  });

  const isViewingSite = props.level === 'sites';
  const hasClient = props.clientId && props.level;

  return (
    <>
      {hasClient && (
        <>
          <AuthorisedSubNavLink
            permissions={['ManageClients']}
            to={`/${props.level}/${props.clientId}/settings/settings`}
            icon="cog"
            label={t('settings.label')}
          />
          {isViewingSite && (
            <>
              <>
                <AuthorisedSubNavLink
                  permissions={['ManageClients']}
                  to={`/${props.level}/${props.clientId}/settings/allowlist`}
                  icon="eye"
                  label={t('settings.allowlist.label')}
                />
              </>
              <>
                <AuthorisedSubNavLink
                  permissions={['ManageClients']}
                  to={`/${props.level}/${props.clientId}/settings/blocklist`}
                  icon="eye-slash"
                  label={t('settings.blocklist.label')}
                />
              </>
              <AuthorisedSubNavLink
                permissions={['ManageClients']}
                to={`/${props.level}/${props.clientId}/settings/frequencycaps`}
                icon="wave-triangle"
                label={t('settings.frequencyCaps.label')}
              />
              <AuthorisedSubNavLink
                permissions={['ManageClients']}
                to={`/${props.level}/${props.clientId}/settings/integrations`}
                icon="plug"
                label={t('settings.integrationsLabel')}
              />
              <AuthorisedSubNavLink
                permissions={['ManageClients']}
                to={`/${props.level}/${props.clientId}/settings/voucher-codes`}
                icon="barcode-read"
                label={t('settings.voucherCodesLabel')}
              />
              <AuthorisedSubNavLink
                permissions={['ManageClients']}
                featureFlag={'tracking-links'}
                to={`/${props.level}/${props.clientId}/settings/tracking-links`}
                icon="link"
                label={t('settings.trackingLinksLabel')}
              />
              <AuthorisedSubNavLink
                permissions={['ManageClients']}
                to={generatePath(MarketingPermissionsRoute.HOME, { siteId: props.clientId })}
                icon="handshake-alt"
                label={t('marketingPermissions:page.link.label')}
              />
              <AuthorisedSubNavLink
                permissions={['ManageClients']}
                to={`/${props.level}/${props.clientId}/settings/supportedlanguages`}
                icon="language"
                label={t('settings.supportedLanguagesLabel')}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default SettingsSubNav;
